import React, { Component } from "react";
import { Accessor, ColorX, GState, LocaleX, NavX, ReqX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XIconButton, XImage, XScroll, XText } from "IZOX/_X";
import Menu from "./_gears/Menu";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { observer } from "mobx-react";
import LangSW from "./_gears/LangSW";
import LoginBtn from "./_gears/LoginBtn";
import { SysConfig } from "__SYSDefault/Config";
import NoContainer from "__SYSDefault/NoContainer";
import Version from "__SYSDefault/Version";
import Funcs from "__SYSDefault/Funcs";
import HeaderM from "./_gears/HeaderM";
import MenuM from "./_gears/MenuM";
import RegisterM from "./_gears/RegisterM";

/**
 * @augments {Component<Props, State>}
 */
class Container extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetVersion();
    });
    this.popstateListener = window.addEventListener("popstate", this.onBackButtonEvent);
    this.unlisten = this.props.history.listen((location, action) => {
      this._ScrollReset();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Container.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.unlisten();
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetVersion = async () => {
    let res = await ReqX.SendBE("/CommonAPI/Env/Info");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        info: payload
      });
      console.warn(`Backend Version: ${payload.backendVersion}\nFrontend Version ${Version}`);
    }
  }

  _ScrollReset = () => {
    this.ref?.scrollTo?.({top: 0});
  }
  
  onBackButtonEvent = () => {
    let {history} = this.props;
    NavX.Refresh(history);
  }
  
  _toPage = (page) => {
    let {history} = this.props;
    NavX.Goto(history, page);
    Funcs.SetMenuClick(page);
    this.ref?.scrollTo?.({top: 0});
  }

  _closeReg = () => {
    GState.setMini(false);
    GState.UPDATE("showCreateAccount", false);
  }

  renderHeader(){
    let {history} = this.props;
    return (
      <VStack shadow style={{position: "fixed", top: 0, zIndex: 500,
        background: ColorX.CSS("pureWhite", 10), overflow: "visible"}} fullWidth>
        <HStack height={120} width={SysConfig.ContentWidth} pV={44} pH={80} style={{overflow: "visible"}}>
          <XButton onPress={() => {
            this._toPage("/Home");
          }}>
            <XImage source="/Images/mutualins-logo-latest.png" width={220}/>
          </XButton>
          <Spacer/>
          <Menu history={history} toPage={this._toPage}/>
          <Spacer/>
          <HStack width={"auto"} style={{overflow: "visible"}}>
            <LoginBtn _closeReg={this._closeReg} history={history}/>
            <LangSW/>
          </HStack>
        </HStack>
        {this.renderRegister()}
      </VStack>
    );
  }

  renderRegister(){
    if(!GState.showCreateAccount || GState.loggedIn) return;
    return (
      <HStack bgColor={ColorX.CSS("Grass")}>
        <HStack width={SysConfig.ContentWidth} height={80} pH={80}>
          <XText bold color={ColorX.CSS("pureWhite")} fontSize={22}>
            {LocaleX.Parse({
              EN: "New user ? Create Account Now",
              TC: "新用戶？ 立即登記用戶"
            })}
          </XText>
          <Spacer/>
          <HStack width={"auto"} spacing={100}>
            <XButton onPress={() => {
              this._closeReg();
              GState.UPDATE("registerStep", "userType");
              GState.UPDATE("registerFormData", {
                userType: "Agent"
              });
              this._toPage("/Register");
            }} padding={0}
              round={30} bW={2} pV={8} pH={24}
              width={200}
              style={{
                borderColor: ColorX.CSS("pureWhite")
              }}
              color={ColorX.CSS("pureWhite")}>
              <HStack>
                <XText bold fontSize={16}>
                  {LocaleX.Parse({
                    EN: "Create account",
                    TC: "登記用戶"
                  })}
                </XText>
              </HStack>
            </XButton>
            <XIconButton onPress={this._closeReg} size={24}>
              <XImage source="/Images/Icons/close.png" noResize width={24} height={24}/>
            </XIconButton>
          </HStack>
        </HStack>
      </HStack>
    );
  }

  renderFooter(){
    return (
      <HStack bgColor={ColorX.CSS("Stone")} height={32} zIndex={2}>
        <XText color={ColorX.CSS("pureWhite")} fontSize={12}>
          {"© 2023 Mutual Insurance Consultants Co. All rights Reserved."}
        </XText>
      </HStack>
    );
  }

  renderNormal(){
    let {children, location} = this.props;
    let isTest = location?.pathname?.startsWith?.("/Test/");
    let isForceNoContainer = NoContainer.includes(location?.pathname);
    if(isTest || isForceNoContainer){
      return (
        <VStack fullWidth fullHeight>
          {children}
        </VStack>
      );
    }
    return (
      <VStack fullWidth fullHeight>
        {this.renderHeader()}
        <XScroll pT={GState.showCreateAccount && !GState.loggedIn ? 200: 120} fullWidth fullHeight id="__scroll__"
          forwardRef={e => this.ref = e}>
          {children}
        </XScroll>
        <Spacer/>
        {this.renderFooter()}
      </VStack>
    );
  }

  renderMobile(){
    let {children, history, location} = this.props;
    let isTest = location?.pathname?.startsWith?.("/Test/");
    let isForceNoContainer = NoContainer.includes(location?.pathname);
    if(isTest || isForceNoContainer){
      return (
        <VStack fullWidth fullHeight>
          {children}
        </VStack>
      );
    }
    return (
      <VStack fullWidth fullHeight>
        <HeaderM history={history} _toPage={this._toPage} _closeReg={this._closeReg}/>
        <RegisterM _closeReg={this._closeReg} _toPage={this._toPage}/>
        {GState.mini && <MenuM history={history} toPage={this._toPage}/>}
        <XScroll fullWidth fullHeight id="__scroll__"
          forwardRef={e => this.ref = e}>
          {children}
        </XScroll>
        <Spacer/>
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default withRouter((observer(Container)));
